import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { styled } from "styled-components";
import { Icon } from "@wayflyer/flyui";
import { IconXmark24Line } from "@wayflyer/flyui-icons/24/line";

const Dialog = DialogPrimitive.Root;

const DialogTrigger = DialogPrimitive.Trigger;

const DialogPortal = DialogPrimitive.Portal;

const DialogClose = DialogPrimitive.Close;

const DialogTitle = DialogPrimitive.Title;

const DialogOverlay = styled(DialogPrimitive.Overlay)`
  position: fixed;
  inset: 0;
  z-index: 50;
  background-color: rgb(255 255 255 / 0.2);
  &.data-[state="open"] {
    opacity: 1;
  }
  &.data-[state="closed"] {
    opacity: 0;
  }
`;

const DialogPrimitiveContent = styled(DialogPrimitive.Content)`
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 50;
  display: grid;
  width: 100%;
  transform: translate(-50%, -50%);
  gap: 16px;
  background-color: #fff;
  background: transparent;
  padding: 16px;
  &.data-[state="open"] {
    opacity: 1;
  }
  &.data-[state="closed"] {
    opacity: 0;
  }
  @media (min-width: 768px) {
    padding: 24px;
  }
`;

const DialogPrimitiveClose = styled(DialogPrimitive.Close)`
  position: absolute;
  right: 40px;
  top: 40px;
  border-radius: 4px;
  border: none;
  background: none;
  opacity: 0.7;
  color: #000;
  padding: 8px;
  background: var(--palette-content-neutral-subtle);
  stroke: var(--palette-content-neutral-onInverse);
  &:hover {
    color: #000;
  }
  @media (min-width: 768px) {
    right: 48px;
    top: 48px;
  }
`;

const DialogContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ children, ...props }, ref) => (
  <DialogPortal>
    <DialogOverlay />
    <DialogPrimitiveContent ref={ref} {...props}>
      {children}
      {/* @ts-expect-error - styled components type complaints */}
      <DialogPrimitiveClose>
        <Icon color="onDark">
          <IconXmark24Line />
        </Icon>
      </DialogPrimitiveClose>
    </DialogPrimitiveContent>
  </DialogPortal>
));
DialogContent.displayName = DialogPrimitive.Content.displayName;

export { Dialog, DialogPortal, DialogOverlay, DialogClose, DialogTrigger, DialogTitle, DialogContent };
